import axios from 'axios'
const buildHash = process.env.VUE_APP_BUILD_HASH

export default {
    install: function () {
        if (process.env.NODE_ENV === 'production') {
            const interval = setInterval(() => {
                axios.get('/build.txt?' + Math.random()).then((response) => {
                    const data = response.data
                    if (data !== buildHash) {
                        clearInterval(interval)
                        window.location.reload()
                    }
                })
            }, 5 * 60 * 1000)
        }
    }
}
